import type { GameModule, ModuleResult } from '../types/game';
import { moduleRegistry } from '../modules/registry';

interface Props { module: GameModule; onComplete: (result: ModuleResult) => void }

export function ModuleRenderer({ module, onComplete }: Props) {
  const Component = moduleRegistry[module.type];
  if (!Component) return <p className="error-message">El tipo de módulo “{module.type}” no está registrado.</p>;
  return <Component module={module} onComplete={onComplete} />;
}

